
const AutoUpdateApp = {
  // 获取本地应用资源版本号
  getVersion: function (newVer, wgturl) {
    var self = this;
    if (window.plus) {
      plusReady(newVer, wgturl);
    } else {
      // console.log("非APP")
      // document.addEventListener('plusready', plusReady(newVer, wgturl), false);
    }
    function plusReady(newVer, wgturl) {
      plus.runtime.getProperty(plus.runtime.appid, (info) => {
        var wgtVer = null;
        wgtVer = info.version;
        // 原格式1.2.0  转换为数字比对大小
        wgtVer = parseInt(wgtVer.split(".").join(""))
        newVer = parseInt(newVer.split(".").join(""))
        //检查更新
        if (wgtVer && wgtVer < newVer) {
          if (window.confirm('检测到更新,是否更新?')) {
            self.downWgt(wgturl)
          }
        }
      })
    }
  },
  //下载wgt文件
  downWgt: function (wgtUrl) {
    var self = this;
    if (window.plus) {
      godownit(wgtUrl);
    } else {
      document.addEventListener('plusready', godownit(wgtUrl), false);
    }
    function godownit(wgtUrl) {
      var totalSize = 0;
      var baifen = 0;
      // plus.nativeUI.showWaiting("下载更新文件...");
      var task = plus.downloader.createDownload(wgtUrl, { filename: "_doc/update/" }, function (d, status) {
        if (status == 200) {
          self.installWgt(d.filename); // 安装wgt包
        } else {
          plus.nativeUI.alert("下载失败！");
        }
        plus.nativeUI.closeWaiting();
      })
      var y = plus.nativeUI.showWaiting("正在下载:0%")
      //监听下载
      task.addEventListener("statechanged", function (download, status) {
        switch (download.state) {
          case 2:
            break;
          case 3:
            //进度条百分比 totalSize为总量，baifen为当前下载的百分比
            if (totalSize == 0) {
              totalSize = parseInt(download.totalSize);
            }
            if (parseInt(download.downloadedSize / totalSize * 100) != baifen) {
              baifen = parseInt(download.downloadedSize / totalSize * 100);
            }
            y.setTitle("下载中" +baifen+'%');
            break;
          case 4:
            plus.nativeUI.alert("下载完成");
            plus.nativeUI.closeWaiting();
            break;
        }
      });
      task.start();
    }
  },
  // 更新应用资源
  installWgt: function (path) {
    if (window.plus) {
      goinstall(path);
    } else {
      document.addEventListener('plusready', goinstall(path), false);
    }
    function goinstall(path) {
      plus.nativeUI.showWaiting("安装更新文件...")
      plus.runtime.install(path, { force: true }, function () {
        plus.nativeUI.closeWaiting()
        plus.nativeUI.alert("应用资源更新完成！", function () {
          plus.runtime.restart()
        })
      }, function (e) {
        plus.nativeUI.closeWaiting();
        plus.nativeUI.alert("安装更新文件失败[" + e.code + "]：" + e.message);
        if (e.code == 10) {
          plus.nativeUI.alert('请清除临时目录');
        }
      });
    }
  }
}
export default {
  AutoUpdateApp
}



// WEBPACK FOOTER //
// ./src/assets/js/newauto.js